import { Injectable } from '@angular/core';
import { EmploymentApiModel } from '../../../api/targeting/model/targeting-search-result.api.model';
import { EmploymentModel } from '../models/employment.model';
import { JournodexEntityFactory } from './journodex-entity.factory';

@Injectable()
export class EmploymentFactory {
    constructor(private journodexEntityFactory: JournodexEntityFactory) {}

    createEmpty(): EmploymentModel {
        return new EmploymentModel();
    }

    async create(apiModel: EmploymentApiModel): Promise<EmploymentModel> {
        const employment = new EmploymentModel(apiModel);

        if (apiModel?.outletInfo) {
            employment.outlet = await this.journodexEntityFactory.createOutlet(apiModel.outletInfo);
        }
        return employment;
    }
}
